import Navbar from "./Navbar";
import AppSidebar from "./Sidebar";
import { getUser } from "@/hooks/useLocalStorage";
import { SidebarProvider } from "@/components/ui/sidebar";

export default function Layout({ children }) {
  const user = getUser();

  return (
    <SidebarProvider>
      <AppSidebar role={user.role} />

      <div className="flex-grow">
        <Navbar user={user} />
        {children}
      </div>
    </SidebarProvider>
  );
}
